import React from 'react';

import {
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

import { Loader } from '../../../Loader';
import { Button } from '../../../Button';
import { useL10n } from '@uplift/hooks';
import { CalendarDateService, DateObject } from '@uplift/services';
import { useRecurringListQuery } from '@uplift/queries';
import { useTimezone } from '@uplift/contexts';


export type RecurringListProps = {
  seriesId: string;
  skipLoading: boolean;
  onSeriesItemCancelClick: (seriesItem: {
    seriesId: string;
    fromDatetime: DateObject;
  }) => void;
};


export const RecurringList = (props: RecurringListProps) => {
  const l10n = useL10n();
  const timezone = useTimezone();
  const { data = [], isLoading } = useRecurringListQuery(props.seriesId, 5, { enabled: !props.skipLoading });

  if (isLoading) {
    return (
      <Loader height="225px" />
    );
  }

  return (
    <Table size="small">
      <TableBody>
        {data?.map(item => {
          const fromDatetime = CalendarDateService.date(item.fromDatetime).tz(timezone);

          return (
            <TableRow key={item.id}>
              <TableCell>{fromDatetime.format('MMM D')}</TableCell>
              <TableCell align="right">
                <Button
                  variant="text"
                  color="primary"
                  size="small"
                  onClick={() => props.onSeriesItemCancelClick?.({
                    seriesId: props.seriesId,
                    fromDatetime: fromDatetime,
                  })}
                >
                  {l10n.general.cancel}
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
